import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Root = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${rem(184)};
  padding: ${rem(24)} ${rem(20)};
  ${mediaQueryUp.tablet} {
    min-height: ${rem(222)};
    padding: ${rem(40)} ${rem(20)};
  }
`

const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 50%;
`

interface Props extends React.ComponentProps<typeof ResponsiveImage> {
  children?: React.ReactNode
}

function CharterHero(props: Props) {
  const {
    alt,
    children,
    className,
    fit = 'center',
    id,
    tabletAspectRatio = '16:9',
    mobileAspectRatio = '1:1',
    ...restOfImageProps
  } = props

  return (
    <Root className={className}>
      <ImageWrapper>
        <ResponsiveImage
          {...restOfImageProps}
          mobileAspectRatio={mobileAspectRatio}
          tabletAspectRatio={tabletAspectRatio}
          id={id}
          alt={alt}
          fit={fit}
          loading="eager"
        />
      </ImageWrapper>
      {children}
    </Root>
  )
}

export default CharterHero
